































































import { defineComponent, ref } from '@vue/composition-api';
import { CallIcon, ChatIcon, CloseIcon, MailIcon } from 'tdesign-icons-vue';

export default defineComponent({
  name: 'SjtuFeedback',
  components: {
    CallIcon,
    ChatIcon,
    CloseIcon,
    MailIcon,
  },
  props: {
    placement: {
      type: String,
      default: 'top',
    },
    inverted: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const visible = ref(false);
    return {
      visible,
    };
  },
});
